var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"diviser"},[_vm._v(" Movimentações do processo ativo ")]),_c('div',{staticClass:"m-t"},[(_vm.bem.processo && _vm.bem.processo.id)?_c('processo-movimentacao',{attrs:{"filtrar-por-processo":_vm.bem.processo.id}}):_c('div',[_vm._v("Este bem não está relacionado à um processo.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }